import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/config";

const WhatsAppFloat = () => (
  <motion.button
    data-testid="whatsapp-float-button"
    aria-label="Chat with Naditra on WhatsApp"
    onClick={() => window.open(waLink("Hi! I want a better price on my trip."), "_blank")}
    className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-wa text-white shadow-[0_16px_40px_-12px_rgba(22,163,74,0.6)] transition-transform duration-300 hover:scale-105 active:scale-95"
    initial={{ opacity: 0, scale: 0 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-wa opacity-25" aria-hidden="true" />
    <MessageCircle className="relative h-6 w-6" />
  </motion.button>
);

export default WhatsAppFloat;
